import React from 'react';
import PictureFlow from './PictureFlow';
import TennisGallery from './TennisGallery';

const AdditionalDetails = () => {
   return (
      <section id="additional" className="additional-section">
         <div className="container" style={{ textAlign: 'center' }}>
            <br />
            <h4>Additional Information!</h4>
            <h3 className="additional-info-text">
               Passionate Tennis Player - Won several trophies at 4.0 level. <br />
               Like to Play Volleyball, Table-Tennis and regularly run/jog for refreshment. <br />
               Have run several 5ks, 10ks, and half marathons.
            </h3>
            <TennisGallery />
            <PictureFlow />
         </div>
      </section>
   );
};

export default AdditionalDetails;
